import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import { Landing } from './landing/pages';
import { WrapperQueryClientProvider } from './shared/components/';

import './index.css';

import 'bootstrap/dist/js/bootstrap.bundle';

function LandingApp({ location, history, loggedIn }: any) {
    if (loggedIn) {
        if (location.state) {
            return <Redirect to={location.state.from} />;
        }

        return <Redirect to="/" />;
    }

    return (
        <WrapperQueryClientProvider>
            <Landing location={location} history={history} />
        </WrapperQueryClientProvider>
    );
}

const mapStateToProps = (store: { auth: { loggedIn: any } }) => ({
    loggedIn: store.auth.loggedIn,
});

export default connect(mapStateToProps)(LandingApp);
